import { camelCase } from "change-case";
import familieKinderIcon from "public/icons/familie-kinder.svg";
import naturatlasIcon from "public/icons/naturatlas.svg";
import ratingFillIcon from "public/icons/rating-fill.svg";
import ratingIcon from "public/icons/rating.svg";
import sehenswertIcon from "public/icons/sehenswert.svg";
import sportGesundheitIcon from "public/icons/sport-gesundheit.svg";
import arrowUpIcon from "public/icons/arrow-up.svg";
import arrowDownIcon from "public/icons/arrow-down.svg";
import tourDistanceIcon from "public/icons/tour-distance.svg";
import tourDurationIcon from "public/icons/tour-duration.svg";
import tourenIcon from "public/icons/touren.svg";
import unterkunftIcon from "public/icons/unterkunft.svg";
import { Icon } from "./Icon";

const icons: Record<string, string> = {
  familieKinderIcon,
  naturatlasIcon,
  ratingFillIcon,
  ratingIcon,
  sehenswertIcon,
  sportGesundheitIcon,
  arrowUpIcon,
  arrowDownIcon,
  tourDistanceIcon,
  tourDurationIcon,
  tourenIcon,
  unterkunftIcon,
};

export const CategoryIcon = ({
  category,
  className,
}: {
  category: Travelguide.Category;
  className?: string;
}) => {
  if (!category.activity) {
    return null;
  }
  const icon = icons[camelCase(`${category.activity.slug}Icon`)];
  return <Icon src={icon} size="85px" className={className} />;
};
